module.exports = __webpack_public_path__ + "static/media/license.a2366854.jpg";